(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["marketplace-reviews"] && !Shopify.designMode) return;
  try {
    
  (function() {
    // Use class-based selectors instead of IDs - more reliable
    function findCarouselElements() {
      // Find all carousel wrappers on the page
      const wrappers = document.querySelectorAll('.marketplace-reviews__carousel-wrapper');
      
      for (let wrapper of wrappers) {
        const carousel = wrapper.querySelector('.marketplace-reviews__carousel');
        const prevButton = wrapper.querySelector('.marketplace-reviews__arrow--prev');
        const nextButton = wrapper.querySelector('.marketplace-reviews__arrow--next');
        
        if (carousel && prevButton && nextButton) {
          const original = carousel.querySelector('.marketplace-reviews__original');
          const cloneStart = carousel.querySelector('.marketplace-reviews__clone-start');
          const cloneEnd = carousel.querySelector('.marketplace-reviews__clone-end');
          
          if (original && cloneStart && cloneEnd) {
            return {
              carousel,
              prevButton,
              nextButton,
              original,
              cloneStart,
              cloneEnd,
              wrapper
            };
          }
        }
      }
      
      return null;
    }
    
    let elements = null;
    
    function scrollCarousel(direction, el) {
      if (!el) {
        el = findCarouselElements();
        if (!el) return;
      }
      
      const { carousel, original, cloneStart } = el;
      
      const cards = original.querySelectorAll('.marketplace-reviews__review-card');
      if (cards.length === 0) return;
      
      // Calculate scroll amount
      const firstCard = cards[0];
      const cardWidth = firstCard.offsetWidth || firstCard.getBoundingClientRect().width || 350;
      const computedStyle = window.getComputedStyle(original);
      const gap = computedStyle.gap || computedStyle.columnGap || '16px';
      const gapValue = parseFloat(gap) || 16;
      const scrollAmount = cardWidth + gapValue;
      
      const originalStart = cloneStart.offsetWidth || 0;
      const originalWidth = original.offsetWidth;
      const currentScroll = carousel.scrollLeft;
      
      if (direction === 'prev') {
        if (currentScroll <= originalStart + 20) {
          const endPosition = originalStart + originalWidth - scrollAmount;
          carousel.scrollTo({ left: endPosition, behavior: 'auto' });
          setTimeout(() => {
            carousel.scrollBy({ left: -scrollAmount, behavior: 'smooth' });
          }, 50);
        } else {
          carousel.scrollBy({ left: -scrollAmount, behavior: 'smooth' });
        }
      } else {
        if (currentScroll >= originalStart + originalWidth - 20) {
          carousel.scrollTo({ left: originalStart, behavior: 'auto' });
          setTimeout(() => {
            carousel.scrollBy({ left: scrollAmount, behavior: 'smooth' });
          }, 50);
        } else {
          carousel.scrollBy({ left: scrollAmount, behavior: 'smooth' });
        }
      }
    }
    
    function init() {
      elements = findCarouselElements();
      
      if (!elements) {
        setTimeout(init, 200);
        return;
      }
      
      const { carousel, prevButton, nextButton, wrapper, original, cloneStart, cloneEnd } = elements;
      
      // Attach handlers directly to buttons
      prevButton.onclick = function(e) {
        e.preventDefault();
        e.stopPropagation();
        scrollCarousel('prev', elements);
        return false;
      };
      
      nextButton.onclick = function(e) {
        e.preventDefault();
        e.stopPropagation();
        scrollCarousel('next', elements);
        return false;
      };
      
      // Also add event listeners
      prevButton.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        scrollCarousel('prev', elements);
      }, true);
      
      nextButton.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        scrollCarousel('next', elements);
      }, true);
      
      // Use event delegation on the wrapper as ultimate fallback
      wrapper.addEventListener('click', function(e) {
        const arrow = e.target.closest('.marketplace-reviews__arrow');
        if (!arrow) return;
        
        e.preventDefault();
        e.stopPropagation();
        
        if (arrow.classList.contains('marketplace-reviews__arrow--prev')) {
          scrollCarousel('prev', elements);
        } else if (arrow.classList.contains('marketplace-reviews__arrow--next')) {
          scrollCarousel('next', elements);
        }
      }, true);
      
      // Initialize scroll position
      const originalStart = cloneStart.offsetWidth || 0;
      if (originalStart > 0) {
        carousel.scrollLeft = originalStart;
      }
      
      // Handle infinite loop on scroll
      let scrollTimeout;
      carousel.addEventListener('scroll', function() {
        clearTimeout(scrollTimeout);
        scrollTimeout = setTimeout(() => {
          const scrollLeft = carousel.scrollLeft;
          const originalStart = cloneStart.offsetWidth || 0;
          const originalWidth = original.offsetWidth;
          const cloneEndWidth = cloneEnd.offsetWidth;
          
          if (scrollLeft >= originalStart + originalWidth + cloneEndWidth - 30) {
            carousel.scrollTo({ left: originalStart, behavior: 'auto' });
          } else if (scrollLeft <= 30) {
            const cards = original.querySelectorAll('.marketplace-reviews__review-card');
            if (cards.length > 0) {
              const firstCard = cards[0];
              const cardWidth = firstCard.offsetWidth || 350;
              const computedStyle = window.getComputedStyle(original);
              const gap = computedStyle.gap || computedStyle.columnGap || '16px';
              const gapValue = parseFloat(gap) || 16;
              const scrollAmount = cardWidth + gapValue;
              carousel.scrollTo({ 
                left: originalStart + originalWidth - scrollAmount, 
                behavior: 'auto' 
              });
            }
          }
        }, 100);
      }, { passive: true });
    }
    
    // Initialize when DOM is ready
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      setTimeout(init, 100);
    }
    
    // Also try after page load
    window.addEventListener('load', function() {
      if (!elements) {
        init();
      }
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
